const axios = require('@/utils/axios')
const { baseURL } = require('@/assets/js/config')
const $http = axios.create({
	baseURL
})

const state = {
	badges: [],
}

const getters = {
	fetchBadges: (state) => state.badges,
}

const actions = {
	loadBadges({ commit }, { token }) {
		return $http.get(`badge`, {
			headers: {
				'x-auth-token': token
			}
		}).then((response) => {
			commit('SET_BADGES', response.data.data)
		})
	},
}

const mutations = {
	SET_BADGES: (state, badges) => {
		state.badges=badges
	},
}

export default {
	state, getters, actions, mutations
}